export default (api) => ({
  uploadStatements: (files, config) => api.post('/statements', files, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    ...config
  }),
})
